import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import { SnackBarModule } from "../../modules/SnackBarModule";
import { ProcessamentoService } from "../../services/ProcessamentoService";
export default {
    name: "GerenciamentoTabelasCargas",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Cargas',
                disabled: true
            }
        ],
        arquivo: null,
        loading: false,
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
        uploadProgress: null,
        blockInputFile: false,
        scheduledList: [],
        objetos: [
            { label: 'Ação', value: 'acao' },
            { label: 'Elemento', value: 'elemento' },
            { label: 'Elemento Item', value: 'elemento-item' },
            { label: 'Fonte', value: 'fonte' },
            { label: 'Grupo', value: 'grupo' },
            { label: 'IPG', value: 'ipg' },
            { label: 'IPU', value: 'ipu' },
            { label: 'Programa', value: 'programa' },
            { label: 'Unidade Executora', value: 'unidade-executora' },
            { label: 'Unidade Orçamentária', value: 'unidade-orcamentaria' }
        ],
        selectedObjetos: []
    }),
    created() {
        this.loadScheduledList();
    },
    watch: {
        selectedObjetos(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.arquivo = null;
                this.uploadProgress = null;
            }
        }
    },
    computed: {
        disabledInputFile () {
            return this.blockInputFile || this.selectedObjetos.length == 0;
        }
    },
    methods: {
        async loadScheduledList() {
            const scheduledList = await ProcessamentoService.scheduled();
            this.scheduledList = scheduledList.data;
        },
        async refreshPage() {
            this.loadScheduledList();
            await SnackBarModule('Lista de Processos Atualizada', 'info');
        },
        async retryProcessamento(item) {
            try {
                const formData = new FormData();
                formData.append('id', item.id);

                const response = await ProcessamentoService.retry(formData);
                if (response) {
                    this.loadScheduledList();
                } 
            } catch (error) {
                console.error('Erro ao tentar reprocessar o item:', error);
            }
        },
        uploadFile() {
            if (!this.arquivo) {
                console.error('Nenhum arquivo selecionado.');
                return;
            }

            this.blockInputFile = true;
            const formData = new FormData();
            formData.append('arquivo', this.arquivo);
            formData.append('type', 'tabelas-basicas');

            this.selectedObjetos.forEach(objeto => {
                formData.append('objetos[]', objeto);
            });

            ProcessamentoService.store(formData)
                .then(response => {

                    if (response.error) {
                        this.blockInputFile = false;
                        this.uploadProgress = null;
                        this.arquivo = null;
                        this.selectedObjetos = [];
                        SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                        return;
                    }

                    let progress = 0;
                    this.blockInputFile = true;
                    this.arquivo = null;
                    const interval = setInterval(() => {
                        progress += Math.random() * 10;
                        if (progress >= 100) {
                            clearInterval(interval);
                            this.uploadProgress = null;
                            this.loadScheduledList();
                        } else {
                            this.uploadProgress = progress;
                        }
                    }, 500);
                })
                .catch(error => {
                    console.error('Erro ao enviar o arquivo:', error);
                    this.uploadProgress = null;
                    this.blockInputFile = false;
                    this.arquivo = null;
                    this.selectedObjetos = [];
                    SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                });
                this.blockInputFile = false;
                this.selectedObjetos = [];
        },
        getStatusClass(item) {
            if (!item.processado) {
                return 'awaiting-process';
            } else if (item.erro) {
                return 'processing-error';
            } else {
                return 'processing-success';
            }
        },
        getStatusText(item) {
            if (!item.processado) {
                return 'Aguardando Processamento';
            } else if (item.erro) {
                return 'Erro de Processamento';
            } else {
                return 'Processamento concluído';
            }
        },
        getStatusIcon(item) {
            if (!item.processado) {
                return 'mdi-clock-outline';
            } else if (item.erro) {
                return 'mdi-alert-circle-outline';
            } else {
                return 'mdi-check-circle';
            }
        },
        getIconColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        getTitleColor(item) {
            if (item.erro) {
                return 'error--text';
            } else if (item.processado) {
                return 'success--text';
            } else {
                return 'warning--text';
            }
        },
        getSubtitleColor(item) {
            if (item.erro) {
                return 'error--text';
            } else if (item.processado) {
                return 'success--text';
            } else {
                return 'warning--text';
            }
        },
        getDividerClass(item) {
            if (item.erro) {
                return 'divider-error';
            } else if (item.processado) {
                return 'divider-success';
            } else {
                return 'divider-warning';
            }
        },
    }
};